import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Heading from '@starbucks-web/pattern-library/lib/components/heading';
import Button from '@starbucks-web/pattern-library/lib/components/button';
import ContentColumn from '@starbucks-web/pattern-library/lib/components/content-column';
import ImageLoader from '@starbucks-web/pattern-library/lib/components/image-loader';

import { configImagesUrlSelector } from 'shared/app/state/selectors/config';

import { commonMessages } from 'shared/app/messages';
import { sharedCallsToAction } from 'shared/app/messages/ctas';

import messages from './messages';
import styles from './styles.cssm';

const HERO_IMAGE_HEIGHT = '579';
const HERO_IMAGE_WIDTH = '448';

const Hero = () => {
  const imageBaseUrl = useSelector(configImagesUrlSelector);

  return (
    <div className="color-greenOnPrimary bg-whiteBackgroundSurfacePrimary3">
      <ContentColumn
        className={`${styles.container} sm-px2 md-px5 xl-px0 lg-py7`}
        innerClassName={`md-flex items-center`}
        size="xl"
      >
        <div
          className={`${styles.childContainer} items-center justify-center px2 lg-px0`}
        >
          <ContentColumn innerClassName="flex flex-column text-center items-center justify-center">
            <Heading
              className="text-bold text-upper mb3 whiteSpace-noWrap color-gold600"
              size="sm"
              tagName="h1"
            >
              <FormattedMessage {...commonMessages.starbucksRewardsTrademark} />
            </Heading>

            <Heading
              className={`${styles.headingText} text-bold whiteSpace-noWrap`}
              size="xxl"
              tagName="h2"
            >
              <FormattedMessage {...messages.header} />
            </Heading>

            <p className={`${styles.bodyText} text-sm lg-text-lg pt4 pb4`}>
              <FormattedMessage {...messages.body} />
            </p>
            <Button href="/account/create" visualStyle="positive">
              <FormattedMessage {...sharedCallsToAction.joinNow} />
            </Button>
          </ContentColumn>
        </div>
        <div
          className={`${styles.childContainer} ${styles.heroImageContainer} flex items-center justify-center`}
        >
          <ImageLoader
            className={`self-end hidden md-block mb4`}
            height="72"
            role="presentation"
            src={`${imageBaseUrl}/sr6-rewards/stars1.svg`}
            width="72"
          />
          <ImageLoader
            alt=""
            className={styles.heroImage}
            height={HERO_IMAGE_HEIGHT}
            lazyLoad={{ enabled: false }}
            role="presentation"
            src={`${imageBaseUrl}/sr6-rewards/hero.png`}
            style={{ borderRadius: HERO_IMAGE_HEIGHT / 2 }}
            width={HERO_IMAGE_WIDTH}
          />
          <ImageLoader
            className={`self-start hidden md-block mt4`}
            height="35"
            role="presentation"
            src={`${imageBaseUrl}/sr6-rewards/stars2.svg`}
            width="24"
          />
        </div>
      </ContentColumn>
    </div>
  );
};

export default Hero;
